/* unplugin-vue-components disabled */import script from "./RolePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./RolePicker.vue?vue&type=script&setup=true&lang=js"

import "./RolePicker.vue?vue&type=style&index=0&id=00443533&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00443533"]])

export default __exports__